/**
 * @file paddle page powered
 * @author wanzhongyun
 */

import classNames from 'classnames';
import { debounce } from 'lodash';
import { useState, useRef } from 'react';
import { IinterPower } from './../../types';
import './style.less';

const Powered: React.FC<IinterPower> = props => {
    const { list } = props;
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [selectItem, setSelectItem] = useState<number>(0);
    const contentRef = useRef<HTMLDivElement>(null);

    const handlePowerClick = (item: IinterPower['list'][0] ,index: number) => {
        setCurrentIndex(index);
        setSelectItem(index);

        const currentDom = contentRef.current?.querySelector(`#${mergeStringId(item.title)}`) as HTMLDivElement;
        if (currentDom) {
            currentDom.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    const mergeStringId = (stringId: string) => stringId.replace(/\s+/g, '');

    const wheelEvent = debounce((e: React.WheelEvent) => requestAnimationFrame(() => {

        // 判断是否还是全屏动画内
        const powerStatus = localStorage.getItem('powerStatus');

        if (powerStatus === 'outerBottom') {
            setSelectItem(3);
            return;
        }

        if (powerStatus === 'outerTop' || !powerStatus) {
            setSelectItem(0);
            return;
        }

        // 判断滚轮的移动方向
        if (!e.ctrlKey) {

            if (e.deltaY > 0 && currentIndex < 3) {
                handlePowerClick(list[currentIndex + 1], currentIndex + 1);
            }

            if (e.deltaY < 0 && currentIndex > 0) {
                handlePowerClick(list[currentIndex - 1], currentIndex - 1);
            }
        }

    }), 100);

    const handleMouseEnter = (index: number) => {
        setSelectItem(index);
    };
    
    return <div
        className='paddle-inter-power-wrapper'
        onWheel={wheelEvent}
        onMouseEnter={() => localStorage.setItem('powerStatus', 'inner')}
    >
        <div className='paddle-inter-power'>
            <div className='paddle-inter-power-header' />
            <div className='paddle-inter-power-footer' />
            <div className='paddle-inter-power-menu'>
                {
                    list.map((item, index) => <div className={classNames('left-card', {
                        'left-card-selected': index === selectItem
                    })} key={item.title + item.link + item.imageUrl} onClick={() => {handlePowerClick(item, index)}}>
                        <div className='left-card-title'>{ item.title }</div>
                        <div className='left-card-desc'>{ item.desc }</div>
                    </div>)
                }
            </div>
        </div>
        <div className='paddle-inter-power-content' ref={contentRef}>
            {
                list.map((item, index) => <div className='right-card' key={item.desc + item.imageUrl} onMouseEnter={() => {handleMouseEnter(index)}} onClick={() => window.open(item.link)}>
                    <div className='right-card-anchor' id={mergeStringId(item.title)} />
                    <img className='right-card-image' src={item.imageUrl}  alt={item.title} />
                    <div className='right-card-content'>
                        <div className='right-card-content-title'>{ item.title }</div>
                        <div className='right-card-content-line' />
                        <div className='right-card-content-desc'>{ item.desc }</div>
                    </div>
                </div>)
            }
        </div>
    </div>
};

export default Powered;